import React from "react";
import CustomCard from "../Card/CustomCard";
import './styles.scss'

const Notification = ({title, imgUri, description}) =>
{
   return (
      <div className='mt-lg-4'>
         <CustomCard cardStyle={'card-box bg-primary'} bodyStyle={'p-4'}>
            <div className="row align-items-center">
               <div className="offset-xl-3 offset-sm-6 col-xl-8 col-sm-6 col-12 img-bg ">
                  <h4 className="d-flex  mb-3">
                     <span className="font-weight-bold text-black ">{title}</span>
                  </h4>
                  <p className="tx-black-7 mb-1">{description}
                  </p>
               </div>
               <img
                  style={{
                     height: 79,
                     position: 'absolute',
                     top: 11,
                     left: 31,
                     // filter: 'drop-shadow(-4px 7px 4px #fff)',
                     borderRadius: 15,
                     // filter: 'brightness(0) invert(1)'
                  }}
                  src={imgUri} alt={title}/>
            </div>
         </CustomCard>
      </div>
   )
}
export default Notification;
